import React from "react";
import styled from "styled-components";

import FilamentTile, {
  FilamentConfig,
} from "../../components/core-components/FilamentTile.tsx";
import PaginatedItems from "../../components/PaginatedItems.tsx";
import {
  deleteCompatibility,
  getPrinterFilaments,
} from "../../../services/filamentService.js";
import { useQuery } from "@tanstack/react-query";

import Modal from "../../components/core-components/Modal.tsx";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/core-components/Button.tsx";
import { useParams } from "react-router-dom";

import AddFilamentCompatibility from "../../components/core-components/AddFilamentCompatibility.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5%;
  width: 90%;
  padding: 20px 0;
  color: var(--tertiary-font-color);
`;
const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
`;

const Subtitle = styled.h4`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  letter-spacing: 1px;
  padding-bottom: 0.5rem;
`;

const PageTitle = styled.h2`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  letter-spacing: 1px;
`;

const notify = () =>
  toast.success("Filament adăugat cu succes !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const notifyError = () =>
  toast.error("Filamentul este deja adăugat!", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });
const PrinterFilamentsPage: React.FC = () => {
  const [isFilamentModalOpen, setFilamentModalOpen] = React.useState(false);

  const { printerId } = useParams();

  const {
    data: filaments,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["filaments", printerId],
    queryFn: () => getPrinterFilaments(printerId),
    enabled: !!printerId,
  });

  const handleDelete = async (filamentID) => {
    try {
      await deleteCompatibility(printerId, filamentID);
      refetch();
    } catch (error) {
      alert(
        "A apărut o eroare la stergerea filamentului. Te rugăm să încerci din nou mai târziu."
      );
    }
  };

  if (!printerId || printerId === "0")
    return <Subtitle>Alege o imprimantă pentru a vedea detalii</Subtitle>;

  return (
    <Wrapper>
      <Header>
        <PageTitle>Filamente compatibile</PageTitle>
        <Button
          id="add-filament-button-modal"
          onClick={() => setFilamentModalOpen(true)}
          text={"Adaugă filament"}
          backgroundColor={"white"}
          outline="var(--secondary-green)"
          color="var(--secondary-green)"
        />
      </Header>

      {isFilamentModalOpen && (
        <Modal
          name="add-printer-filament-modal"
          title={"Adaugă filament"}
          onClose={() => setFilamentModalOpen(false)}
          content={
            <AddFilamentCompatibility
              closeAddMode={(result) => {
                setFilamentModalOpen(false);
                if (result === "success") {
                  notify();
                  refetch();
                } else if (result === "error") {
                  notifyError();
                }
              }}
              printerId={printerId}
            />
          }
        />
      )}
      <Container>
        <PaginatedItems
          items={filaments || []}
          isLoading={isLoading}
          maxItemsPerPage={30}
          renderItem={(filament: {
            colorCode: string;
            colorName: string;
            filamentConfig: FilamentConfig;
          }) => (
            <FilamentTile
              colorCode={filament.colorCode}
              colorName={filament.colorName}
              filamentConfig={filament.filamentConfig}
              readonly={true}
              isAdminMode={true}
              onWeightUpdated={() => {}}
              onDelete={handleDelete}
            />
          )}
        />
      </Container>

      <ToastContainer />
    </Wrapper>
  );
};

export default PrinterFilamentsPage;
